import React from 'react';
import projectsjson from "./project.json";




const Portfolio = () => {
    return ( 
        <div className='portfolio' name='portfolio'>
            <h1 data-aos="fade-right" data-aos-delay='200'>
                Latest Projects
            </h1>
            <div className='porfolio_projects'>
                <div className='projects'>
                    {
                    projectsjson.map(projectjson=>{
                        return(
                            <div className='project' data-aos="zoom-in-up" data-aos-offset='140'>
                        <div className='ifame_projects'>
                            <img src={projectjson.project_img} />
                        </div>
                        <div className='text_project'>
                            <h1>{projectjson.project_name}</h1>
                            <div className='use_program_language'>
                                {projectjson.prgram_langua.map(program_la=>{
                                    return(
                                        <p>{program_la}</p>
                                    )
                                })}
                            </div>
                            <p>
                                {projectjson.paragraf}
                            </p>
                            <div className='button_for_view_code_demo'>
                                <a href={projectjson.coding_link} target='_blank'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                                        <path d="M7.4 10.6L2.8 6L7.4 1.4L6 0L0 6L6 12L7.4 10.6ZM12.6 10.6L17.2 6L12.6 1.4L14 0L20 6L14 12L12.6 10.6Z" fill="#211B12"/>
                                    </svg>
                                    Code
                                </a>
                                <a href={projectjson.demo_link} target='_blank'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20" fill="none">
                                        <path d="M19.77 3.02995L21.17 4.42995L8.43 17.17L2.83 11.57L4.23 10.17L8.43 14.37L19.77 3.02995ZM19.77 0.199951L8.43 11.54L4.23 7.33995L0 11.57L8.43 20L24 4.42995L19.77 0.199951Z" fill="#211B12"/>
                                    </svg>
                                    Demo
                                </a>
                            </div>
                        </div>
                    </div>
                        )
                    })
                    }
                </div>
            </div>
        </div>
     );
}
 
export default Portfolio;